<div class="shimmer">

  <div class="block headline mb-5"></div>

  <div class="block line mb-3"></div>
  <div class="block line mb-3"></div>
  <div class="block line mb-3"></div>
  <div class="block line mb-3"></div>
  <div class="block line short"></div>

</div>
